

/**
 * 指令任务管理
 * instructRouterUrl 日志跳转链接
 * accountId，
 * accountName
 * platform
 */
import React from 'react'

import {
    message,
    Spin,
    Input,
    DatePicker,
    Checkbox, Select,
    Tooltip,
    Popconfirm, Button
} from 'antd'

import moment from 'moment';
import 'moment/locale/zh-cn';
import Tools from './tools/Tools'
import AuthButton from './components/antdReset/AuthButton'
import WWTable from './components/Table'
import TableIOP from "./components/Table/TableIOP";
import ExportFileInstruct from './components/ExportFileInstruct'
import DeviceSearch from './components/DeviceSearch'
import withRouter  from './tools/withRouter'
import DeviceType from './components/DeviceType'
const {RangePicker} = DatePicker;
import AddBatchInstructModal from "./components/AddBatchInstructModal";
import BatchInstructModalMicDetail from "./components/BatchInstructModalMicDetail";
import InstructStatusSelect from "./components/InstructStatusSelect";
const Option = Select.Option
// import columnsParams from "./configs/params";
import AddBatchInstructModalMic from "./components/AddBatchInstructModalMic";
class BatchInstructMgt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            loading: false,
            pageSize: 10,
            currentPage: 1,
            count: 0,
            record: {},
            windowHeight:window.innerHeight,
            winW:window.innerWidth,
            dateFormat:'YYYY-MM-DD',
            content: '',
            name:'',
            startTime:'',
            endTime:'',
            status:'',
            //todo iop 需要兼容
            /*accountId: localStorage.getItem("currentAccountId") ? localStorage.getItem("currentAccountId") : localStorage.getItem('accountId'),
            accountName: localStorage.getItem("currentAccountName") ? localStorage.getItem("currentAccountName") : localStorage.getItem('accountName'),*/
            accountId:this.props.accountId,
            accountName: this.props.accountName,
            carId:"",
            taskName:""

        };
        this.getDataList = this.getDataList.bind(this);
        this.searchDataList = this.searchDataList.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.handleDataListChange = this.handleDataListChange.bind(this);
        this.disabledDate = this.disabledDate.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleStartDate = this.handleStartDate.bind(this);
        this.handleStartExeTime = this.handleStartExeTime.bind(this);
        this.cancelTask = this.cancelTask.bind(this);
        this.getParamUrl = this.getParamUrl.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.goLog = this.goLog.bind(this);
        window.setAccountId = this.setAccountId.bind(this);
        this.resetParams = this.resetParams.bind(this);
        this.getParams = this.getParams.bind(this);
    }

    componentDidMount() {
        this.getDataList();
        let that = this;
        window.addEventListener('resize', this.onWindowResize)
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize)
    }
    getParams(){
        const {status,name,taskName,imei,startTime,endTime,carId,startExeTime} = this.state;
        if (moment(startTime).unix()>moment(endTime).unix()) {
            message.error(Strings.rs10480)
            return false
        }
        let model ={}
        if (!Tools.isNull(status)) {
            model.status = status
        }
        if (name) {
            model.name = name
        }
        if(taskName){
            model.taskName = taskName
        }
        if (imei) {
            model.imei = imei
        }
        if(carId){
            model.carId = carId
        }
        if(Tools.isDeviceMgt(this.props.platform)){
            if (startTime) {
                model.startTime = moment(startTime).unix()
            }
            if (endTime) {
                model.endTime = moment(endTime).unix()
            }
        }else{
            if(startTime){
                model.startTime = moment(startTime).startOf("day").unix()
                model.endTime = moment(startTime).endOf("day").unix()
            }
            if(startExeTime){
                model.startExeTime = moment(startExeTime).startOf("day").unix()
                model.endExeTime = moment(startExeTime).endOf("day").unix()
            }
        }
        return model;
    }
    handleStartDate(startTime,dateString){
        this.setState({
            startTime: startTime
        })
    }
    handleStartExeTime(startExeTime,dateString){
        this.setState({
            startExeTime: startExeTime
        })
    }
    onWindowResize() {
        this.setState({
            windowHeight: window.innerHeight,
            winW:window.innerWidth
        });
    }

    setAccountId(accountId,accountName) {
        this.setState({
            accountId,accountName
        })
    }

    searchDataList() {
        this.setState({
            currentPage: 1,
            loading: true
        }, () => {
            this.getDataList()
        })
    }

    getParamUrl(url) {
        const {imei, status,accountId,name,startTime,endTime,startExeTime,taskName,carId} = this.state;
        if (!Tools.isNull(status)) {
            url += '&status=' + status;
        }
        if (name) {
            url += '&name=' + name;
        }
        if(taskName){
            url += '&taskName=' + taskName;
        }
        if (imei) {
            url += '&imei=' + imei;
        }
        if(carId){
            url += '&carId=' + carId;
        }
        if (moment(startTime).unix()>moment(endTime).unix()) {
            message.error(Strings.rs10480)
            return false
        }
        if(Tools.isDeviceMgt(this.props.platform)){
            if (startTime) {
                url += '&startTime=' + moment(startTime).unix();
            }
            if (endTime) {
                url += '&endTime=' + moment(endTime).unix();
            }
        }else{
            if(startTime){
                url += "&startTime="+moment(startTime).startOf("day").unix();
                url += "&endTime="+moment(startTime).endOf("day").unix();
            }
            if(startExeTime){
                url += "&startExeTime="+moment(startExeTime).startOf("day").unix();
                url += "&endExeTime="+moment(startExeTime).endOf("day").unix();
            }
        }

        return url
    }

    /*获取设备列表*/
    getDataList() {
        const {currentPage, pageSize} = this.state;
        let url = this.getParamUrl(`${Tools.getApiUrl("bathInstructTaskList",this.props.platform)}currentPage=${currentPage}&pageSize=${pageSize}`);
        let urlCount =  this.getParamUrl(Tools.getApiUrl("bathInstructTaskCount",this.props.platform));
        if(!url || !urlCount) {
            return
        }

        let that = this;
        that.setState({
            loading: true,
        });

        Tools.fetch(urlCount,'GET',function (data) {
            that.setState({
                loading: false,
            });
            if(data.code === 0) {
                that.setState({
                    count:data.data,
                },()=>{
                    Tools.fetch(url,'GET',function (data) {
                        that.setState({
                            loading: false,
                        });
                        if(data.code === 0) {
                            that.setState({
                                dataList:data.data,
                            })
                        } else {
                            message.error(data.message)
                        }
                    })
                })
            } else {
                message.error(data.message)
            }
        })
    }
    //iop 导出
    exportExcel() {
        let url = this.getParamUrl(Tools.getApiUrl("exportBathInstructTask",this.props.platform))
        if(!url) {
            return
        }
        url += `&zoneId=${Tools.getZoneName()}`;
        window.open(Tools.getNoCacheExportURL(url))
    }

    //切换分页
    handleDataListChange(current, pageSize) {
        this.setState({
            currentPage: current,
            pageSize
        }, () => {
            this.getDataList();
        })

    }


    handleDate(dates, dateStrings) {
        this.setState({
            endTime: dates && dates[1] ,
            startTime: dates && dates[0]
        })
    }

    //结束时间不可选择的时间
    disabledDate(current) {
        const endTime = this.state.endTime;
        const startTime = this.state.startTime;

        if (!endTime || !startTime) {
            return false;
        }
        const tooGreater = startTime.valueOf() > endTime.valueOf();
        const outOfFreeRange = endTime.valueOf() <= startTime.valueOf();
        return tooGreater || outOfFreeRange;
    }

    goLog(record) {//todo 列表需要带日志的URL
        const { navigate,instructRouterUrl } = this.props;
        navigate(instructRouterUrl,{state:{ name: record.name }})
    }

    cancelTask(id) {
        let url = `${Tools.getApiUrl("cancelTask",this.props.platform)}${id}`
        let that = this;
        let type = Tools.isDeviceMgt(this.props.platform)?"POST":"DELETE"
        Tools.fetch(url,type,function (data) {
            if(data.code === 0) {
                message.success(Strings.rs14374)
                that.searchDataList();
            } else {
                message.error(data.message)
            }
        })
    }
    resetParams(){
        this.setState({
            name: '',
            startTime:"",
            endTime:"",
            startExeTime:"",
            endExeTime:"",
            taskName:"",
            status:"",
            carId:""
        },()=>{
            this.refs.deviceSearchInst.resetSearchValue(null);
        })
    }
    render() {
        let that = this;
        const {windowHeight, winW, dateFormat, pageSize, count, currentPage,startTime,endTime,status,
            accountId, accountName,startExeTime,taskName,exeTimeOpen,startTimeOpen} = this.state;
        let columnsParams = {
            mic:[
                {title:Strings.taskname,width:"150px",dataIndex:'taskName'},
                {title:Strings.directivename,width:"150px",dataIndex:'instructionName'},
                {title:Strings.sendtype,width:"150px",dataIndex:'sendType',
                    render:(text,record)=>{
                        return Tools.getLabelFromGlobalEnums("enums.cmdSendType",null,text)
                    }
                },
                {title:Strings.devicecount,width:"150px",dataIndex:'deviceNum'},
                {title:Strings.exesuccesscount,width:"150px",dataIndex:'exeSuccessNum'},
                {title:Strings.exefailecount,width:"150px",dataIndex:'exeFailNum'},
                {title:Strings.notexecount,width:"150px",dataIndex:'unExecutedNum'},
                {title:Strings.createTime,width:"200px",dataIndex:'createTime',
                    render:(text,record)=>{
                        return Tools.formatTimeYMDHms(text)
                    }},
                {title:Strings.operatetime,width:"200px",dataIndex:'operationTime',
                    render:(text,record)=>{
                        return Tools.formatTimeYMDHms(text)
                    }},
                {title:Strings.operator,width:"150px",dataIndex:'operator'},

                {title:Strings.status,width:"100px",dataIndex:'taskStatus',
                    render:(text,record)=>{
                        return Tools.getLabelFromGlobalEnums("enums.cmdTaskStatus",null,text)
                    }},
                {title:Strings.lastexetime,width:"200px",dataIndex:'lastExecTime',
                    render:(text,record)=>{
                        return Tools.formatTimeYMDHms(text)
                    }},
                {title:Strings.opts,width:"100px",dataIndex:'',fixed: 'right',
                    render: function (text, record) {
                        return  <div className="more-operation inline-flex">
                            <Tooltip transitionName="" title={Strings.rs10093} placement="top" >
                                <i className="iconfont icon-xiangqing blue" onClick={()=>{
                                    that.refs.detail_mic && that.refs.detail_mic.showDetailModal(record.taskId,record.taskDetailId);
                                }}/>
                            </Tooltip>
                            {record.status == 1 && !Tools.isMonitor() ||  record.taskStatus == 1?
                                <Popconfirm title={Strings.rs14380}
                                            onConfirm={() => {
                                                that.cancelTask(record.id || record.taskId)
                                            }}
                                            overlayClassName={"micCancelPop"}
                                            okText={Strings.rs10581}
                                            placement="top"
                                            cancelText={Strings.rs10054}>
                                    <Tooltip transitionName="" placement="top" title={Strings.rs10054}>
                                        <a><i className={"iconfont icon-quxiao blue"}/></a>
                                    </Tooltip>
                                </Popconfirm>:null}
                        </div>
                    }}
            ],
            iop:[
                {title:Strings.rs14375,width:"10%",dataIndex:'name'},
                {title: Strings.rs14394,//指令名称
                    dataIndex: 'instructionName',
                    width: "10%",
                }, {
                    title: Strings.rs10065,
                    dataIndex: 'deviceNum',
                    width: "8%",
                }, {
                    title: Strings.lsTime,//时间
                    dataIndex: 'timeDesc',
                    width: "10%",
                }, {
                    title: Strings.rs14376,
                    dataIndex: 'rulesDesc',
                    width: "8%",
                }, {
                    title: Strings.rs14377,
                    dataIndex: 'operator',
                    width: "10%",
                }, {
                    title: Strings.rs14378,
                    dataIndex: 'operationTimeDesc',
                    width: "10%",
                }, {
                    title: Strings.rs10106,//状态
                    dataIndex: 'statusDesc',
                    width: "10%",
                }, {
                    title: Strings.rs14379,
                    dataIndex: 'lastExecTimeDesc',
                    width: "10%",
                },
                {title:Strings.opts,width:"100px",dataIndex:'',fixed: 'right',
                    render: function (text, record) {
                        return  <div className="more-operation inline-flex">
                            {/*//iop 有任务日志*/}
                           <Tooltip transitionName="" title={Strings.rs10958} placement="top" >
                                <i className="iconfont icon-rizhi" onClick={()=>that.goLog(record)}/>
                            </Tooltip>
                            <Tooltip transitionName="" title={Strings.rs10093} placement="top" >
                                <i className="iconfont icon-xiangqing blue" onClick={()=>{
                                    that.refs.add.showModal(record.id)
                                }}/>
                            </Tooltip>
                            {record.status == 1 && !Tools.isMonitor() ||  record.taskStatus == 1?
                                <Popconfirm title={Strings.rs14380}
                                            onConfirm={() => {
                                                that.cancelTask(record.id || record.taskId)
                                            }}
                                            overlayClassName={"micCancelPop"}
                                            okText={Strings.rs10581}
                                            placement="top"
                                            cancelText={Strings.rs10054}>
                                    <Tooltip transitionName="" placement="top" title={Strings.rs10054}>
                                        <a><i className={"iconfont icon-guanbi1 blue"}/></a>
                                    </Tooltip>
                                </Popconfirm>:null}
                        </div>
                    }}
            ]
        }
        let columns = columnsParams[that.props.platform];
        const {platform} = this.props;
        let header = <div className="search_content">
                <div className="search_row mg_bottom16">
                    <div className="row_item">
                        <span className="label">{Strings.rs14375 || Strings.taskname}</span>
                        <Input
                            onChange={(e) => {
                                this.setState({
                                    name: Tools.removeSpace(e.target.value),
                                })
                            }}
                            value={this.state.name} placeholder={Strings.rs14325}/>
                    </div>
                    <div className="row_item">
                            <span className="label">{Strings.rs14381}</span>
                            <InstructStatusSelect showAll={true} value={status} platform={platform} onChange={(value)=>this.setState({status:value})}/>
                    </div>
                    <div className="row_item"  id="instruct_mgt_picker">
                        <span className="label">{Strings.rs14378}</span>
                        <RangePicker
                            size={"middle"}
                            showTime={true}
                            picker="date"
                            allowClear={true}
                            value={[startTime ? moment(startTime, dateFormat) : '', endTime ? moment(endTime, dateFormat) : '']}
                            format={dateFormat}
                            onChange={this.handleDate}
                            // disabledDate={this.disabledDate}
                            getPopupContainer={() => document.getElementById("instruct_mgt_picker")}/>
                    </div>
                </div>
                <div className="search_row">
                    <div className="row_item">
                        <span className="label">{Strings.rs10026 || Strings.deviceName}</span>
                        <DeviceType ref="deviceaName" type={(imei)=>this.setState({imei})} imei={this.state.imei} accountId={accountId}/>
                    </div>
                    <div className="row_item flex_end">
                        <Button className={"mgl15"} type={"primary"} title={Strings.rs10025} onClick={this.searchDataList}>
                            <i className={"iconfont icon-sousuo"}></i>
                        </Button>
                    </div>
                </div>
            </div>;
        let header_mic = <div className={"searchWrapper"}>
            <div className={"firstRow searchRow"}>
                <div className={"searchDiv"}>
                    <div className={"searchItem"}>
                        <div className={"item"}>
                            <label className={"labelfont"}>{Strings.rs14375 || Strings.taskname}</label>
                            <Input className={"w240 mgl7"}
                                   maxLength={64}
                                   onChange={(e) => {
                                       this.setState({
                                           taskName: Tools.removeSpace(e.target.value),
                                       })
                                   }}
                                   value={taskName} placeholder={Strings.rs10846}/>
                        </div>
                        <div className={"item mgt15"} id={"instruct_start_time"}>
                            <label className={"labelfont"}>{Strings.createTime}</label>
                            <DatePicker className={"w240 mgl7"}
                                size={"middle"} showTime={false}  picker="date"  allowClear={true}
                                value={startTime ? moment(startTime, dateFormat) : ''}
                                format={dateFormat} open={startTimeOpen}
                                        onOpenChange={(startTimeOpen)=>this.setState({startTimeOpen})}
                                onChange={this.handleStartDate}
                                getPopupContainer={() => document.getElementById("instruct_start_time")}/>

                        </div>
                    </div>
                    <div className={"searchItem"}>
                        <div className={"item"}>
                            <label className={"labelfont"}>{Strings.rs14381}</label>
                            <Select className={"w240 mgl7"} value={status} onChange={(value)=>this.setState({status:value})}>
                                <Option value={""}>{Strings.all}</Option>
                                {Tools.getOptionsFromGlobalEnums("enums.cmdTaskStatus","select")}
                            </Select>

                        </div>
                        <div className={"item mgt15"} id={"instruct_exe_time"}>
                            <label className={"labelfont"}>{Strings.lastexetime || Strings.rs14379}</label>
                            <DatePicker className={"w240 mgl7"}
                                size={"middle"}
                                showTime={false}
                                        picker="date"
                                value={startExeTime ? moment(startExeTime, dateFormat) : ''}
                                format={dateFormat} open={exeTimeOpen}
                                        onOpenChange={(exeTimeOpen)=>this.setState({exeTimeOpen})}
                                onChange={this.handleStartExeTime}
                                getPopupContainer={() => document.getElementById("instruct_exe_time")}/>
                        </div>
                    </div>
                    <div className={"searchItem"}>
                        <div className={"item"}>
                            <label className={"labelfont"}>{Strings["field.car"]}</label>
                            <DeviceSearch ref="deviceSearchInst" className={"mg15"} platform={this.props.platform}
                                          onChange={(carId)=>{
                                this.setState({carId})
                            }}/>
                        </div>
                        <div className={"item mgt15"}>
                            &nbsp;
                        </div>
                    </div>
                </div>
                <div>
                    <div className={"btnswrapper"}>
                        <AuthButton className={"mgl30"} type="primary" authKey={true} onClick={()=>{currentPage !== 1 ? this.setState({currentPage:1},this.getDataList):this.getDataList()}}>{Strings.search || "搜索"}</AuthButton>
                        <AuthButton className={"mgl10 mgt15"} type="reset" authKey={true} onClick={this.resetParams}>{Strings.reset ||"重置"}</AuthButton>
                    </div>
                </div>
            </div></div>
        return (
            <Spin delay={2000} spinning={this.state.loading} >
                <div className={"mainContainer commonbox"}>
                        {Tools.isDeviceMgt(this.props.platform)?header:header_mic}
                        {Tools.isDeviceMgt(this.props.platform)?Tools.isMonitor()?null:<div className="device-batch space_between mg_bottom10">
                            <div className="flex">
                                <a className="batch_a" onClick={()=>{
                                    this.refs.add.showModal()
                                }}>
                                    <i className={"iconfont icon-tianjiaanniu"}></i>
                                    {Strings.rs10009}</a>
                            </div>
                        </div>:null}
                    {Tools.isDeviceMgt(this.props.platform)?<div className="component_table_content new_app_table_content"
                                                                 style={{height: windowHeight - 168, position: 'relative'}}>
                        <TableIOP className="new_app_table"
                                 dataSource={this.state.dataList}
                                 columns={columns}
                                 pageSize={pageSize}
                                 count={count}
                                 currentPage={currentPage}
                                 innerHeight={windowHeight - 238}
                                 exportExcel={this.exportExcel}
                                 onShowSizeChange={this.handleDataListChange}/>
                    </div>:<div className="border_table">
                        <div className={"bathOptsWrapper"}>
                            <div className={"leftopts"}>
                                <AuthButton className={"widauto mgl0 ft13"} widthType={2} type="primary" authKey={true} onClick={()=>{
                                    this.refs.add_mic.showModal();
                                }}>{Strings.addTask || "新增任务" }</AuthButton>
                            </div>
                            <ExportFileInstruct params={this.getParams()} type={"commandTask"} ></ExportFileInstruct>
                        </div>
                        <WWTable className="new_app_table"
                                 bordered={false}
                                 columns={columns}
                                 pageSize={pageSize}
                                 count={count}
                                 currentPage={currentPage}
                                 pagination={true}
                                 dataSource={this.state.dataList}
                                 innerHeight={windowHeight - 288}
                                 width={winW-231}
                                 onChange={this.handleDataListChange}
                                 onShowSizeChange={(currentPage,pageSize)=>{
                                     this.handleDataListChange(1,pageSize)
                                 }}
                                 hiddenPagination={false}
                        />
                    </div>}
                    <AddBatchInstructModalMic accountId={accountId} {...this.props} accountName={accountName} ref={'add_mic'} refresh={this.searchDataList}></AddBatchInstructModalMic>
                    <AddBatchInstructModal  accountId={accountId} {...this.props} accountName={accountName} ref={'add'} refresh={this.searchDataList}/>
                    <BatchInstructModalMicDetail accountId={accountId} {...this.props} accountName={accountName} ref={'detail_mic'} refresh={this.searchDataList}></BatchInstructModalMicDetail>
                </div>

            </Spin>
        )
    }
}

export default withRouter(BatchInstructMgt)
